/**
 * Generated runtime TestId mirror for frontend/src/pages/MyRequests.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const MyRequestsTestIds = {
  colBeneficiary: "col-beneficiary",
  colCreatedAt: "col-created-at",
  colFgBeneficiary: "col-fg-beneficiary",
  colFgCreatedAt: "col-fg-created-at",
  colFgItems: "col-fg-items",
  colFgJustification: "col-fg-justification",
  colFgStatus: "col-fg-status",
  colItems: "col-items",
  colJustification: "col-justification",
  colStatus: "col-status",
  myRequestsPage: "my-requests-page",
  linkFgRequest: (request_id: string) => `link-fg-request-${request_id}`,
  linkFgRequestPrefix: () => "link-fg-request-" as TestIdPrefix,
  linkRequest: (request_id: string) => `link-request-${request_id}`,
  linkRequestPrefix: () => "link-request-" as TestIdPrefix
} as const;
